export enum RequestChannel {
    Voice = 1,
    Chat,
    Web
}
